import React from 'react';
import ReactDOM from 'react-dom';
import 'bootstrap/dist/css/bootstrap.css';
import './assets/css/style.css';
import './assets/css/dietStyle.css';
import './assets/css/dietPlanStyle.css';
import './assets/css/dietPlansStyle.css';
import './assets/css/riskStyle.css';
import './assets/css/ProDietPlanStyle.css';
import 'react-loading-skeleton/dist/skeleton.css'
import App from './App';
import { AppContextProvider } from "./context/app-context"; 
import reportWebVitals from './reportWebVitals';

ReactDOM.render(
  <React.StrictMode>
    <AppContextProvider>
      <App />
    </AppContextProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
